var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../../templates/components/appliances/washing-drying-cleaning.template.html');
require('../../../../libs/handlebars/handlebars-helpers.ts');

var TheView = GenericView.extend({
    el: '#washing',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var params = {
            appliances: [
                {"electric_appliance": "Dishwasher", "applianceType": "Dishwasher", "cycle_power": 1280.0.toFixed(2), "stand_by_power": 2.00.toFixed(2), "cycle_power_factor": 0.80.toFixed(2), "cycle_duration": 60, "stand_by_duration":  0},
                {"electric_appliance": "Washing machine", "applianceType": "Washing_Machine", "cycle_power": 405.54.toFixed(2), "stand_by_power": 1.00.toFixed(2), "cycle_power_factor": 0.90.toFixed(2), "cycle_duration": 140, "stand_by_duration":  0},
                {"electric_appliance": "Tumble dryer", "applianceType": "Tumble_Dryer", "cycle_power": 2500.0.toFixed(2), "stand_by_power": 1.00.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 60, "stand_by_duration":  0},
                {"electric_appliance": "Electric shower", "applianceType": "Electric_Shower", "cycle_power": 6500.0.toFixed(2), "stand_by_power": 0.00.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 15, "stand_by_duration":  0},
                {"electric_appliance": "Hair dryer", "applianceType": "Hair_Dryer", "cycle_power": 1300.0.toFixed(2), "stand_by_power": 2.20.toFixed(2), "cycle_power_factor": 0.75, "cycle_duration": 9, "stand_by_duration":  0},
                {"electric_appliance": "Hair straightener", "applianceType": "Hair_Straightener", "cycle_power": 85.00.toFixed(2), "stand_by_power": 0.60.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 9, "stand_by_duration":  0},
                {"electric_appliance": "Electric shaver", "applianceType": "Electric_Shaver_Clipper", "cycle_power": 20.00.toFixed(2), "stand_by_power": 0.00.toFixed(2), "cycle_power_factor": 0.6.toFixed(2), "cycle_duration": 15, "stand_by_duration":  0},
                {"electric_appliance": "Electric toothbrush", "applianceType": "Electric_Toothbrush", "cycle_power": 0.00.toFixed(2), "stand_by_power": 1.60.toFixed(2), "cycle_power_factor": 0.6.toFixed(2), "cycle_duration": 2, "stand_by_duration":  0},
                {"electric_appliance": "Ironing machine", "applianceType": "Ironing_Machine", "cycle_power": 1000.0.toFixed(2), "stand_by_power": 0.00.toFixed(2), "cycle_power_factor": 0.98, "cycle_duration": 30, "stand_by_duration":  0},
                {"electric_appliance": "Electric water heater", "applianceType": "Electric_Water_Heater", "cycle_power": 4000.0.toFixed(2), "stand_by_power": 0.00.toFixed(2), "cycle_power_factor": 1.0.toFixed(2), "cycle_duration": 30, "stand_by_duration":  0},
                {"electric_appliance": "Vacuum cleaner", "applianceType": "Vacuum_Cleaner", "cycle_power": 1000.0.toFixed(2), "stand_by_power": 1.70.toFixed(2), "cycle_power_factor": 0.65, "cycle_duration": 30, "stand_by_duration":  0}
            ]
        };

        this.$el.html(this.template(params));
    },
    getWDCAppliances: function() {
        var wdc_appliances = [];

        var rows = $("#washingTable tbody").find("tr");
        $.each(rows, function(index, value) {
         var temp = {
             electric_appliance: $(this).find(".electric_appliance").html(),
             cycle_power: parseFloat($(this).find(".cycle_power").html()),
             stand_by_power: parseFloat($(this).find(".stand_by_power").html()),
             cycle_power_factor: parseFloat($(this).find(".cycle_power_factor").html()),
             cycle_duration: parseFloat($(this).find(".cycle_duration").html()),
             stand_by_duration: parseFloat($(this).find(".stand_by_duration").html()),
             applianceType: $(this).find(".electric_appliance").data("appliance-type")
         }
         wdc_appliances.push(temp);
        });

        return wdc_appliances;
    }
});

module.exports= TheView;